import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AddTemplateComponent } from './add-template/add-template.component';
import { async, firstValueFrom } from 'rxjs';
import { WhatsappTemplatesService } from 'src/app/business-service/whatsapp-templates/whatsapp-templates.service';

@Component({
  selector: 'app-template-builder',
  templateUrl: './template-builder.component.html',
  styleUrls: ['./template-builder.component.scss'],
})
export class TemplateBuilderComponent implements OnInit {
  @ViewChild(AddTemplateComponent) child!: AddTemplateComponent;

  @Input() templateId!: string;
  @Input() isUserEditing: boolean = false;
  @Input() isViewOnly: boolean = false;


  templateForm!: FormGroup;
  private formInitialized = false;

  constructor(
    private _modalControllerService: ModalController,
    private _templateService: WhatsappTemplatesService
  ) { }

  ngOnInit() {
  }

  onFormReady(form: FormGroup) {
    this.templateForm = form;
    this.formInitialized = true;

    if (this.templateId) {
      this.loadTemplateDetails();
    }
    if (this.isViewOnly) {
      {
        this.templateForm.disable();
      }
    }
  }

  // Load Templates INTO Child
  async loadTemplateDetails() {
    try {
      if (!this.templateId || !this.formInitialized) return;

      const templateData = await firstValueFrom(
        this._templateService.getWhatsappTemplateById(this.templateId)
      );
      if (!templateData) return;

      // Basic fields
      this.templateForm.patchValue({
        name: templateData.name,
        templateCategory: templateData.templateCategory,
        language: templateData.language,
        templateType: templateData.templateType,
        headerText: templateData.headerText || "",
        body: templateData.body,
        footer: templateData.footer || "",
        buttonType: templateData.buttonType || "none"
      });

      // QUICK REPLIES
      this.child.quickReplies.clear();
      if (templateData.buttonType === "quick" && templateData.quickReplies?.length) {
        templateData.quickReplies.forEach((reply: any) => {
          this.child.quickReplies.push(
            this.child.createQuickReplyGroup(reply)   // FIXED: no private fb access
          );
        });
      }

      // CALL BUTTONS
      this.child.callButtons.clear();
      if (templateData.buttonType === "call" && templateData.callButtons?.length) {
        templateData.callButtons.forEach((btn: any) => {
          this.child.callButtons.push(
            this.child.createCallButtonGroup(btn)     // FIXED: clean API
          );
        });
      }

    } catch (error) {
      console.error("Error loading template:", error);
    }
  }
  submitFromParent() {
    if (!this.templateForm || this.templateForm.invalid) return;

    this.child.onSubmit();   // child handles its API + emits response
  }

  saveAndNext() {
    if (!this.templateForm || this.templateForm.invalid) return;

    this.child.onSubmit();
  }

  //  PARENT RECEIVES API RESPONSE
  onChildSubmit(apiResponse: any) {
    console.log('Parent: API successful:', apiResponse);
  }

  onSaveDraft() {
    console.log('Draft Saved:', this.templateForm.value);
  }

  closeModal() {
    this._modalControllerService.dismiss();
  }
}
